import { DOG_LIABILITY_NXT_CONSTANTS } from '@flows/configs/dogLiabilityNxt/constants'
import type { TransformedOption } from '@flows/core/types/stepContentTypes'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const dog_breed_type = () => {
  return [
    {
      type: 'choice',
      as: 'button',
      name: 'breed_type',
      options: DOG_LIABILITY_NXT_CONSTANTS.dogBreedTypes.map((breed): TransformedOption => {
        return {
          label: {
            type: 'translatableText',
            translationKey: `sharedFlows_dogLiabilityNxt:steps.dog_list.breed_type.${breed}`,
          },
          value: breed,
        }
      }),
    },
  ] as const satisfies AnyStepConfiguration['stepContent']
}

export default dog_breed_type
